import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotate } from '@fortawesome/free-solid-svg-icons'

import { selectFabricationLoading } from '../selector/selectors';

export default (props) => {
  const loading = useSelector(selectFabricationLoading)

  const clazz = classnames({
    'pcb-loading-overlay': true,
    hidden: !loading,
  })
  return (
    <div className={clazz}>
      <div className="spin">
        <FontAwesomeIcon icon={faRotate} spin />
      </div>
    </div>
  )
}